import React from "react";
import { Link } from "react-router-dom";

import styles from "./style.module.scss";

import level0 from "assets/images/level/level0.svg";
import level1 from "assets/images/level/level1.svg";
import level2 from "assets/images/level/level2.svg";
import level3 from "assets/images/level/level3.svg";
import level4 from "assets/images/level/level4.svg";
import level5 from "assets/images/level/level5.svg";

const ProfilePicture = ({ userLevel, image, profileSetting }) => {
  return (
    <div class={styles.ProfilePicture}>
      <img
        src={`/level${userLevel}.svg`}
        alt="level"
        class={styles.ProfilePicture__level}
      />
      <div
        class={styles.avatar}
        style={{
          right: profileSetting && "20px",
          top: profileSetting && "18px",
        }}
      >
        {image}
      </div>
    </div>
  );
};

export default ProfilePicture;
